// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-table[data-v-46af3f0f] {\n  margin: 0 10px;\n}\n.el-header[data-v-46af3f0f] {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
